import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IUserNoteAttributes extends IModelAttributes {
	userId: string;
	noteId: string;

	user: Models.UserEntity | Models.IUserEntityAttributes;
	note: Models.NotesEntity | Models.INotesEntityAttributes;
}

@entity('UserNote')
export default class UserNote extends Model implements IUserNoteAttributes {
	@observable
	@attribute()
	public userId: string;

	@observable
	@attribute()
	public noteId: string;

	@observable
	@attribute({ isReference: true })
	public user: Models.UserEntity;

	@observable
	@attribute({ isReference: true })
	public note: Models.NotesEntity;

	constructor(attributes?: Partial<IUserNoteAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.userId) {
				this.userId = attributes.userId;
			}
			if (attributes.noteId) {
				this.noteId = attributes.noteId;
			}

			if (attributes.user) {
				if (attributes.user instanceof Models.UserEntity) {
					this.user = attributes.user;
					this.userId = attributes.user.id;
				} else {
					this.user = new Models.UserEntity(attributes.user);
					this.userId = this.user.id;
				}
			} else if (attributes.userId !== undefined) {
				this.userId = attributes.userId;
			}

			if (attributes.note) {
				if (attributes.note instanceof Models.NotesEntity) {
					this.note = attributes.note;
					this.noteId = attributes.note.id;
				} else {
					this.note = new Models.NotesEntity(attributes.note);
					this.noteId = this.note.id;
				}
			} else if (attributes.noteId !== undefined) {
				this.noteId = attributes.noteId;
			}
		}
	}
}
